import { Conditional, Else, Grid, Heading, If, Paragraph, Row } from "@hex-insights/core";
import { useActivePageRegistration, useHistory } from "@hex-insights/router";
import {
	ButtonLink,
	Icon,
	StudentComponents,
	useReEnrollmentStudentHealthOverviewQuery,
} from "@hex-insights/verita-romania.shared";
import { ReEnrollmentLayout } from "../../Components";
import { reEnrollmentDataConsentPageInfo } from "../../DataConsentPage/pageinfo";
import { reEnrollmentGuardiansIndexPageInfo } from "../../GuardiansPage/IndexPage/pageinfo";
import { getReEnrollmentStudentFilter } from "../../Utilities";
import { reEnrollmentStudentHealthDetailPageInfo } from "../DetailPage/pageinfo";
import { reEnrollmentStudentHealthIndexPageInfo } from "./pageinfo";
import generalStyles from "../../general.module.css";

const responsiveGridTracks = {
	0: 1,
	700: 2,
};

export function ReEnrollmentStudentHealthIndexPage() {
	useActivePageRegistration(reEnrollmentStudentHealthIndexPageInfo);

	const { loading, data } = useReEnrollmentStudentHealthOverviewQuery({
		variables: {
			filters: getReEnrollmentStudentFilter(),
		},
	});

	const history = useHistory();

	return (
		<ReEnrollmentLayout
			footerContent={
				<Row justify="space-between">
					<ButtonLink variant="link" to={reEnrollmentGuardiansIndexPageInfo.to}>
						<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
							<Icon.ArrowLeft size={24} /> Back
						</Row>
					</ButtonLink>

					<ButtonLink variant="primary" to={reEnrollmentDataConsentPageInfo.to}>
						Looks Good, Continue
					</ButtonLink>
				</Row>
			}
		>
			<Heading.H1 className={generalStyles["heading"]}>Review Student Health Details</Heading.H1>

			<Paragraph>
				Please review the information below to make sure it's correct. Click the pencil icon to edit details.
			</Paragraph>

			<Conditional>
				<If condition={loading && !data}>
					<span>Loading...</span>
				</If>
				<Else>
					<Grid responsiveTracks={responsiveGridTracks} gap="1.5rem">
						{data?.studentConnection.edges.map(({ node }) => (
							<StudentComponents.StudentHealthReviewCard
								key={node.id}
								student={node}
								onEditClick={() => history.push(reEnrollmentStudentHealthDetailPageInfo.to(node.id))}
							/>
						))}
					</Grid>
				</Else>
			</Conditional>
		</ReEnrollmentLayout>
	);
}
